import styled from 'styled-components';

interface BoxProps {
	$checked?: boolean;
}

export const Container = styled.label`
	max-width: max-content;
	cursor: pointer;
	display: flex;
	align-items: center;
	gap: 8px;
	user-select: none;
`;

export const Input = styled.input`
	clip: rect(0 0 0 0);
	clip-path: inset(50%);
	height: 1px;
	overflow: hidden;
	position: absolute;
	white-space: nowrap;
	width: 1px;
`;

export const Label = styled.div``;

export const Box = styled.div<BoxProps>`
	display: flex;
	align-items: center;
	color: ${({ theme, $checked }) => ($checked ? theme.colors.primary.medium : '#ced4da')};
	font-size: 20px;
`;
